import { padLeftZero } from './padLeftZero';

export function formatDate(value, format = '') {
    const date = new Date(value);
    const nowDate = new Date();
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    const o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
    };
    if (
        nowDate.getFullYear() === date.getFullYear() &&
        nowDate.getMonth() === date.getMonth() &&
        nowDate.getDate() === date.getDate() &&
        new RegExp('today').test(format)
    ) {
        return '今天';
    }
    format = format.replace(/today/, '');
    for (const k in o) {
        if (new RegExp(`(${k})`).test(format)) {
            const str = o[k] + '';
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
        }
    }
    return format;
}
